window.updateGlobalCartCount = function() {
    fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
            const cartBadges = document.querySelectorAll('.cart-item-count');
            cartBadges.forEach(badge => {
                badge.textContent = cart.item_count;
                if (cart.item_count > 0) {
                    badge.classList.remove('is-hidden');
                } else {
                    badge.classList.add('is-hidden');
                }
            });
        })
        .catch(error => console.error('Error fetching cart total:', error));
};

function markCentredHeadings() {
    const headingElements = document.querySelectorAll('.block-heading');

    headingElements.forEach(element => {
        const computedStyle = window.getComputedStyle(element);

        if (computedStyle.textAlign === 'center') {
            element.classList.add('block-heading--centred');
        } else {
            // Optional: Remove it if alignment changes in the Theme Editor
            element.classList.remove('block-heading--centred');
        }
    });
}

// 2. Run the function when the live page loads
document.addEventListener('DOMContentLoaded', markCentredHeadings);

// 3. Shopify Theme Editor integration
// This forces the script to re-run whenever a merchant changes settings in the editor
document.addEventListener('shopify:section:load', markCentredHeadings);
document.addEventListener('shopify:block:select', markCentredHeadings);

function updateHeaderHeight() {
    const header = document.getElementById('siteHeader');
    if (!header) return;
    document.documentElement.style.setProperty('--header-height', `${header.offsetHeight}px`);
}

// Double rAF ensures we read offsetHeight after first paint, not before
requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        updateHeaderHeight();
    });
});

window.addEventListener('resize', updateHeaderHeight);

document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'header') {
        requestAnimationFrame(() => requestAnimationFrame(updateHeaderHeight));
    }
});

function updateAnnouncementBarHeight() {
    // Presence is detected purely in CSS via body:has(.announcement-bar);
    // this only refines the offset to the bar's exact rendered height.
    const bar = document.querySelector('.announcement-bar');
    if (bar) {
        document.documentElement.style.setProperty('--announcement-bar-height', `${bar.offsetHeight}px`);
    }
}

// Double rAF ensures we read offsetHeight after first paint, not before
requestAnimationFrame(() => {
    requestAnimationFrame(() => {
        updateAnnouncementBarHeight();
    });
});

window.addEventListener('resize', updateAnnouncementBarHeight);

document.addEventListener('shopify:section:load', (e) => {
    if (e.detail.sectionId === 'announcement-bar') {
        requestAnimationFrame(() => requestAnimationFrame(updateAnnouncementBarHeight));
    }
});

document.addEventListener('shopify:section:unload', (e) => {
    if (e.detail.sectionId === 'announcement-bar') {
        requestAnimationFrame(() => requestAnimationFrame(updateAnnouncementBarHeight));
    }
});